import { render } from "./TabEmotional.vue?vue&type=template&id=d7ed25c6"
import script from "./TabEmotional.vue?vue&type=script&lang=js"
export * from "./TabEmotional.vue?vue&type=script&lang=js"
script.render = render

export default script